import { Spin } from 'antd';
import { useParams } from 'react-router-dom';
import OrderStep from './step';
import OrderOperate from './order-operate';
import OrderBaseInfo from './base-info';
import RecipientInformation from './recipient-information';
import OrderItemList from './item-list';
import OrderOperateHistories from './operate-histories';
import OrderPointHistories from './point-histories';
import OmsOrderPaymentInfo from './payment-info';
import OnlinePaymentRecord from './online-payment-record';
import OfflinePaymentRecord from './offline-payment-record';
import OmsOrderMultiplePayList from './OmsOrderMultiplePayList';
import CryptoPaymentRecord from './crypto-payment-record';
import LayoutFloatButton from 'components/layout-float-button';
import OrderEmailHistory from './order-email-history';
import { useOrderDetail } from 'commons/hooks/use-order-detail';

const OrderView = () => {
  const { id } = useParams<{ id: string }>();
  const {
    omsOrderDetail,
    omsOrderDetailV2,
    reloadOrderDetailV2,
    omsOrderMultiplePayList,
    productList,
  } = useOrderDetail(id ? Number(id) : undefined);

  if (!omsOrderDetail) return <Spin />;

  const stockPlace = productList[0] ? productList[0].stockPlace : undefined;

  const { status } = omsOrderDetail;

  return (
    <div className="space-y-4">
      <OrderStep
        status={status}
        createTime={omsOrderDetail.createTime}
        paymentTime={omsOrderDetail.paymentTime}
        deliveryTime={omsOrderDetail.deliveryTime}
        receiveTime={omsOrderDetail.receiveTime}
        stockPlace={stockPlace}
      />

      <OrderOperate
        omsOrderDetail={omsOrderDetail}
        productList={productList}
        tagList={omsOrderDetailV2?.tagList || []}
        taxRegime={omsOrderDetailV2?.taxRegime}
      />

      <OrderBaseInfo
        stockPlace={stockPlace}
        omsOrderDetail={{
          ...omsOrderDetail,
          tagList: omsOrderDetailV2?.tagList || [],
          coupon: omsOrderDetailV2?.coupon,
          invoiceNo: omsOrderDetailV2?.invoiceNo,
        }}
      />

      <RecipientInformation omsOrderDetail={omsOrderDetail} />

      {/* <RelatedShipment omsOrderDetail={omsOrderDetail} /> */}

      <OrderItemList
        omsOrderDetail={omsOrderDetail}
        productList={productList}
      />

      <OmsOrderPaymentInfo
        omsOrderDetail={omsOrderDetail}
        logisticsCost={omsOrderDetailV2?.logisticsCost ?? 0}
        freightWaiverReason={omsOrderDetailV2?.freightWaiverReason}
        onLogisticsCostSaved={reloadOrderDetailV2}
      />

      <OmsOrderMultiplePayList
        omsOrderDetail={omsOrderDetail}
        data={omsOrderMultiplePayList}
        stockPlace={stockPlace}
      />

      <CryptoPaymentRecord
        omsOrderDetail={omsOrderDetail}
        stockPlace={stockPlace}
      />

      <OnlinePaymentRecord
        omsOrderDetail={omsOrderDetail}
        orderPayList={omsOrderDetailV2?.orderPayList || []}
        stockPlace={stockPlace}
      />

      <OfflinePaymentRecord
        omsOrderDetail={omsOrderDetail}
        stockPlace={stockPlace}
      />

      <OrderPointHistories orderId={omsOrderDetail.id} />

      <OrderOperateHistories
        omsOrderDetail={omsOrderDetail}
        stockPlace={stockPlace}
      />

      <OrderEmailHistory orderId={omsOrderDetail.id} stockPlace={stockPlace} />

      <LayoutFloatButton />
    </div>
  );
};

export default OrderView;
